// extracted by mini-css-extract-plugin
export default {"Comment":"Comment_qD1Km","avatar":"avatar_gh81m","blogname":"blogname_CrA1a","date":"date_huv1a","comment":"comment_Hkg6j","options":"options_kidGb"};